import React from "react";
import sampleVideo from "./Cloudimages/01_SNOWLAND_30SEC FINAL OUTPUT.mp4"; // Replace with a grocery-themed video if available

import img2 from "./orgenic.avif";
const GroceryCardsLanding = () => {
  return (
    <>
      <style>{`
        .grocery-banner {
          display: flex;
          flex-direction: column;
          align-items: center;
          background: #4e1f5cff;
          border-radius: 10px;
          color: #fff;
          padding: 40px 5%;
        }

        /* Top Heading */
        .top-section {
          text-align: center;
          margin-bottom: 50px;
          max-width: 800px;
        }

        .top-section h2 {
          font-size: 2.8rem;
          margin-bottom: 15px;
          font-weight: bold;
        }

        .top-section p {
          font-size: 1.1rem;
          line-height: 1.6;
          color: #f0f0f0;
        }

        /* Banner Content */
        .banner-content {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          flex-wrap: wrap;
          width: 100%;
          gap: 30px;
        }

        /* Left Section */
        .banner-left {
          flex: 1 1 300px;
          max-width: 600px;
        }

        .banner-left h1 {
          font-size: 2.8rem;
          font-weight: bold;
          line-height: 1.3;
          margin-bottom: 20px;
        }

        .banner-left p {
          font-size: 1rem;
          line-height: 1.6;
          margin-bottom: 25px;
        }

        /* Right Section (Video) */
        .banner-right {
          flex: 1 1 300px;
          max-width: 600px;
          text-align: center;
        }

        .video-box {
          width: 100%;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 6px 20px rgba(0,0,0,0.3);
        }

        .video-box video {
          width: 100%;
          height: auto;
          display: block;
        }

        /* Responsive */
        @media (max-width: 1024px) {
          .top-section h2 {
            font-size: 2.2rem;
          }
          .banner-left h1 {
            font-size: 2.2rem;
          }
        }

        @media (max-width: 768px) {
          .banner-content {
            flex-direction: column;
            align-items: center;
          }

          .banner-left,
          .banner-right {
            max-width: 100%;
          }

          .banner-left h1 {
            font-size: 2rem;
          }

          .banner-left p {
            font-size: 0.95rem;
          }
            .imag-groceries-data{
            width: 200px !important;
            }
        }

        @media (max-width: 480px) {
          .grocery-banner {
            padding: 30px 3%;
          }

          .banner-left h1 {
            font-size: 1.6rem;
          }

          .banner-left p {
            font-size: 0.9rem;
          }

          .video-box {
            width: 100%;
          }
        }
      `}</style>

      <div className="grocery-banner">
        {/* Optional Top Section */}
        <div className="top-section">
          <h2>Fresh Groceries Delivered</h2>
          <p>Get farm-fresh fruits, vegetables, and daily essentials delivered right to your doorstep.</p>
        </div>

        {/* Banner Content */}
        <div className="banner-content">
          {/* Left Section */}
          <div className="banner-left">
            <h1>
              Healthy & Fresh <br /> Groceries
            </h1>
            <p>
              Enjoy a wide variety of fresh produce, organic vegetables, and grocery staples, all sourced directly from trusted suppliers.
            </p>
          </div>

          {/* Right Section (Video) */}
          <div className="banner-right">
            <div >
              <img src={img2} style={{ height: "300px" }} className="imag-groceries-data" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GroceryCardsLanding;
